export default __webpack_public_path__ + "static/media/signature_3.29e0b9b4.png";